import React from "react";
import CardGroup from "../../../components/cardGroup";
import HeaderSection from "../../../components/headerSection";
import Footer from "../home/footer";
import { SubscriptionPlans } from "../../../components/SubscriptionPlans";
import { HEADING_COLOR } from "../../../constants/colors";

export const Pricing = () => (
  <>
    <HeaderSection title="Pricing" />
    <div className="bg-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4" style={{ color: HEADING_COLOR }}>Choose Your Career Path</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Select the plan that best fits your career development needs and unlock AI-powered insights
          </p>
        </div>

        <SubscriptionPlans variant="subscription" hideButtons={true} />

        <div className="mt-16 pt-12 border border-gray-300">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Need Help Choosing?</h2>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Not sure which plan is right for you? Start with our free tier to explore basic features, or contact our career specialists for personalized recommendations.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="px-8 py-4 border-2 border-purple-600 text-purple-600 font-medium rounded-lg hover:bg-purple-50 transition-colors">
                Contact Support
              </button>
              <button className="px-8 py-4 border-2 border-purple-600 text-purple-600 font-medium rounded-lg hover:bg-purple-50 transition-colors">
                View Feature Comparison
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </>
);
